module.exports = __webpack_public_path__ + "static/img/TRANSPORTATIONBottom.6f542b42.png";